import axios from "axios";
import {TERMS_ACCEPTANCES_PATH} from "../api/endpointPaths.mjs";
import {getIdToken} from "../auth/authProviders";
import type {AccountBoundAxiosConfig} from "../utils/AxiosUtils";
import type {TermsAcceptancePayload} from "./termsAcceptanceReplay";

/**
 * The authenticated terms-acceptance record (api#744).
 *
 * Auth rides the shared axios instance's request interceptor (`utils/AxiosUtils`), but unlike ordinary
 * requests this legal record first verifies the cached account against restored Firebase auth, then binds
 * the interceptor to that exact uid. A mismatch therefore rejects before ownership moves; a later account
 * change rejects the request so the replay coordinator can return a newly moved claim to the unclaimed
 * slot with the account that clicked, if any (api#780).
 *
 * The endpoint is idempotent per terms version: the first acceptance on file is kept, so replaying an
 * already-recorded version is a successful no-op rather than a moved timestamp.
 */
export async function verifyTermsAcceptanceAccount(accountId: string): Promise<void> {
	await getIdToken(false, accountId);
}

export async function submitTermsAcceptance(
	accountId: string,
	payload: TermsAcceptancePayload,
): Promise<void> {
	const config: AccountBoundAxiosConfig = {expectedFirebaseUid: accountId};
	await axios.post(TERMS_ACCEPTANCES_PATH, payload, config);
}
